import React from 'react';

function useForceUpdate() {
  let [value, setState] = React.useState(true);
  return () => setState(!value);
}
export default useForceUpdate;
